/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Provide the sites for your app. Each site includes site id, and its localization configuration.
// You can also provide aliases for your locale. They will be used in place of your locale id when generating paths across the app
module.exports = [
    {
        id: 'DynamiteGarageCA',
        countryCode: 'CA',
        l10n: {
            supportedCurrencies: ['CAD'],
            defaultCurrency: 'CAD',
            defaultLocale: 'en-CA',
            supportedLocales: [
                {
                    id: 'en-CA',
                    alias: 'ca',
                    preferredCurrency: 'CAD'
                },
                {
                    id: 'fr-CA',
                    alias: 'fr-ca',
                    preferredCurrency: 'CAD'
                }
            ],
            brands: [
                {
                    id: 'garage',
                    rootCategory: 'root_gar_ca'
                },
                {
                    id: 'dynamite',
                    rootCategory: 'root_dyn_ca'
                }
            ]
        }
    },
    {
        id: 'DynamiteGarageUS',
        countryCode: 'US',
        l10n: {
            supportedCurrencies: ['USD'],
            defaultCurrency: 'USD',
            defaultLocale: 'en-US',
            supportedLocales: [
                {
                    id: 'en-US',
                    alias: 'us',
                    preferredCurrency: 'USD'
                }
            ],
            brands: [
                {
                    id: 'garage',
                    rootCategory: 'root_gar_us'
                },
                {
                    id: 'dynamite',
                    rootCategory: 'root_dyn_us'
                }
            ]
        }
    }
]
